import { render, staticRenderFns } from "./ParameteModalSis.vue?vue&type=template&id=e973b5ce&"
import script from "./ParameteModalSis.vue?vue&type=script&lang=js&"
export * from "./ParameteModalSis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports